<i class="fa {{icon}}"></i>